import { theme } from '@weave/theme';

export function DetailRow({
  label,
  value,
  actions,
}: {
  label: React.ReactNode;
  value: React.ReactNode;
  actions?: React.ReactNode;
}) {
  return (
    <dl style={{ display: 'flex', alignItems: 'baseline', gap: '1rem', margin: 0 }}>
      <dt
        style={{
          fontWeight: 600,
          color: theme.colors.neutral40,
          margin: 0,
          textTransform: 'uppercase',
          fontSize: theme.font.size.small,
        }}
      >
        {label}
      </dt>
      <dd
        style={{
          margin: 0,
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
        }}
      >
        <span>{value}</span>
        {actions && <div>{actions}</div>}
      </dd>
    </dl>
  );
}
